import { Button } from './button';
import { BaseButtonProps } from './button.types';

export const ButtonDanger = ({ onClick, disabled, type = 'button', className, children }: BaseButtonProps) => {
  return (
    <Button
      type={type}
      disabled={disabled}
      className={className}
      classNameDisabledStyle="primary rounded-full bg-gray-400 text-gray-500 focus:ring-gray-500"
      classNameStyle="primary default bg-red-700 text-white hover:bg-red-600 focus:ring-red-700 hover:cursor-pointer"
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
